class CollectionPasswordGate {
  constructor() {
    this.collectionId = document.querySelector('[data-collection-id]')?.dataset.collectionId;
    this.passwordRequired = document.querySelector('[data-collection-password]')?.dataset.collectionPassword;
    this.contentWrapper = document.querySelector('[data-collection-content]');
    this.passwordModal = document.querySelector('collection-password-modal');
    
    if (!this.collectionId || !this.passwordRequired) {
      return;
    }
    
    this.storageKey = `collection-${this.collectionId}-authenticated`;
    this.init();
  }

  init() {
    // Check if already authenticated
    if (this.isAuthenticated()) {
      this.showContent();
    } else {
      this.hideContent();
      this.showPasswordModal();
    }

    // Listen for password submission
    if (this.passwordModal) {
      const form = this.passwordModal.querySelector('form');
      if (form) {
        form.addEventListener('submit', this.handlePasswordSubmit.bind(this));
      }
    }
  }

  isAuthenticated() {
    const stored = sessionStorage.getItem(this.storageKey);
    return stored === 'true';
  }

  setAuthenticated() {
    sessionStorage.setItem(this.storageKey, 'true');
  }

  handlePasswordSubmit(event) {
    event.preventDefault();
    
    const form = event.target;
    const passwordInput = form.querySelector('input[name="password"]');
    const errorMessage = form.querySelector('.form__message');
    const submitButton = form.querySelector('button[type="submit"]');
    
    const enteredPassword = passwordInput.value;
    const correctPassword = this.passwordRequired;
    
    // Clear any previous errors
    if (errorMessage) {
      errorMessage.style.display = 'none';
    }
    
    // Disable submit button during validation
    if (submitButton) {
      submitButton.disabled = true;
    }
    
    if (enteredPassword === correctPassword) {
      // Correct password
      this.setAuthenticated();
      this.hidePasswordModal();
      this.showContent();
    } else {
      // Incorrect password
      if (errorMessage) {
        errorMessage.style.display = 'block';
      }
      passwordInput.setAttribute('aria-invalid', 'true');
      passwordInput.classList.add('field--error');
      
      // Re-enable submit button
      if (submitButton) {
        submitButton.disabled = false;
      }
      
      // Clear and refocus input
      passwordInput.value = '';
      passwordInput.focus();
    }
  }

  hideContent() {
    if (this.contentWrapper) {
      this.contentWrapper.style.display = 'none';
    }
  }

  showContent() {
    if (this.contentWrapper) {
      this.contentWrapper.style.display = 'block';
    }
  }

  hidePasswordModal() {
    if (this.passwordModal) {
      const details = this.passwordModal.querySelector('details');
      if (details) {
        details.removeAttribute('open');
      }
      this.passwordModal.style.display = 'none';
    }
  }

  showPasswordModal() {
    if (this.passwordModal) {
      this.passwordModal.style.display = 'block';
      const details = this.passwordModal.querySelector('details');
      if (details) {
        details.setAttribute('open', '');
      }
      
      // Auto-focus password input
      const passwordInput = this.passwordModal.querySelector('input[type="password"]');
      if (passwordInput) {
        setTimeout(() => passwordInput.focus(), 100);
      }
    }
  }
}

// Custom element definition
class CollectionPasswordModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Initialize the modal behavior similar to DetailsModal
    const details = this.querySelector('details');
    if (details) {
      this.setupFocusTrap(details);
    }
  }

  setupFocusTrap(details) {
    const summary = details.querySelector('summary');
    const modalContent = details.querySelector('.modal__content');
    
    if (!summary || !modalContent) return;

    // Close on background click
    details.addEventListener('click', (event) => {
      if (event.target === details) {
        details.removeAttribute('open');
      }
    });

    // Prevent closing the modal in password-protected mode
    // The modal should only close when correct password is entered
  }
}

// Define custom element
if (!customElements.get('collection-password-modal')) {
  customElements.define('collection-password-modal', CollectionPasswordModal);
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CollectionPasswordGate();
  });
} else {
  new CollectionPasswordGate();
}
